import { render, staticRenderFns } from "./UserMoneyList.vue?vue&type=template&id=71735ca8&"
import script from "./UserMoneyList.vue?vue&type=script&lang=js&"
export * from "./UserMoneyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports